// src/SmartSummary.js
import React, { useMemo } from "react";
import {
  FaRegFileAlt,
  FaRegCalendarAlt,
  FaInbox,
  FaExclamationTriangle,
} from "react-icons/fa";
import './SmartSummary.css'; 

/**
 * items: Array<{
 *   id: string,
 *   subject: string,
 *   body: string
 * }>
 */
export default function SmartSummary({ items }) {
  const { tasks, meetings, documents, alerts } = useMemo(() => {
    const t = [], m = [], d = [], a = [];

    items.forEach(({ id, subject, body }) => {
      const text = `${subject} ${body}`.toLowerCase();

      // 文档：检测常见文件扩展名
      if (/\b(pdf|docx?|xlsx?|pptx?)\b/.test(text)) {
        d.push(subject || "(no subject)");
        return;
      }

      // 会议：检测“meeting”、时间格式、明天/后天 等
      if (
        /\bmeeting\b/.test(text) ||
        /\b\d{1,2}:\d{2}\b/.test(text) ||
        /\btomorrow\b|\btoday\b|\btonight\b/.test(text)
      ) {
        m.push(subject || "(no subject)");
        return;
      }

      // 警示：检测“password expires”、“subscription”、“alert”等
      if (
        /\b(password expires|subscription renewal|alert|notice|urgent)\b/.test(
          text
        )
      ) {
        a.push(subject || "(no subject)");
        return;
      }

      // 其他所有归为任务
      t.push(subject || "(no subject)");
    });

    return {
      tasks: t,
      meetings: m,
      documents: d,
      alerts: a,
    };
  }, [items]);

  // 如果没有任何分类
  if (
    tasks.length === 0 &&
    meetings.length === 0 &&
    documents.length === 0 &&
    alerts.length === 0
  ) {
    return <p className="smart-summary-empty">No items to summarize.</p>;
  }

  return (
    <div className="lexmail-smart-summary">
      <h3></h3>
      <div className="smart-summary-grid">
        {/* Tasks */}
        <div className="lexmail-summary-card">
          <h4>
            <FaRegFileAlt /> Tasks
          </h4>
          {tasks.length > 0 ? (
            <ul>
              {tasks.map((t, i) => (
                <li key={i}>{t}</li>
              ))}
            </ul>
          ) : (
            <p className="empty">No tasks found</p>
          )}
        </div>

        {/* Meetings */}
        <div className="lexmail-summary-card">
          <h4>
            <FaRegCalendarAlt /> Meetings
          </h4>
          {meetings.length > 0 ? (
            <ul>
              {meetings.map((mt, i) => (
                <li key={i}>{mt}</li>
              ))}
            </ul>
          ) : (
            <p className="empty">No meetings scheduled</p>
          )}
        </div>

         {/* Alerts */}
        <div className="lexmail-summary-card">
          <h4>
            <FaInbox /> Documents
          </h4>
          {documents.length > 0 ? (
            <ul>
              {documents.map((doc, i) => (
                <li key={i}>{doc}</li>
              ))}
            </ul>
          ) : (
            <p className="empty">No important documents</p>
          )}
        </div>

        {/* Alerts */}
        <div className="lexmail-summary-card">
          <h4>
            <FaExclamationTriangle /> Alerts
          </h4>
          {alerts.length > 0 ? (
            <ul>
              {alerts.map((al, i) => (
                <li key={i}>{al}</li>
              ))}
            </ul>
          ) : (
            <p className="empty">No alerts</p>
          )}
        </div>
      </div>
    </div>
  );
}
